<div class="pattern-editor">
  <mat-form-field class="pattern-container">
    <mat-chip-grid #patternList
      cdkDropList
      cdkDropListOrientation="horizontal"
      (cdkDropListDropped)="drop($event)"
      >
      @for (element of patternElements; track element) {
        <mat-chip
          cdkDrag [value]="element.value"
          (removed)="removeElement(element)">
          {{element.label}}
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip>
      }
      <input
        placeholder="Skriv tekst"
        #elementInput
        [formControl]="elementCtrl"
        [matAutocomplete]="auto"
        [matChipInputFor]="patternList"
        [matChipInputSeparatorKeyCodes]="separatorKeyCodes"
        (matChipInputTokenEnd)="addElement($event)">
    </mat-chip-grid>
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
      @for (element of filteredElements | async; track element) {
        <mat-option [value]="element">
          {{element.label}}
        </mat-option>
      }
    </mat-autocomplete>
    @if (control.hasError('required')) {
      <mat-error>Skal udfyldes.</mat-error>
    }
    @if (control.hasError('pattern')) {
      <mat-error>Skal indeholde løbenummer.</mat-error>
    }
  </mat-form-field>
  <div class="sample-container">
    <span class="sample-label">Eksempel:</span> <span class="sample-value">{{ sample }}</span>
  </div>
</div>
